<template>
  <div class="current-option" @click="onBack">
    <div class="contact-option" v-if="option === 'sms'"><span><fa-icon icon="sms" fixed-width/> SMS </span></div>
    <div class="contact-option" v-if="option === 'email'"><span><fa-icon icon="envelope"  fixed-width /> Email</span></div>
    <div class="contact-option" v-if="option === 'whatsapp'"><span><fa-icon :icon="['fab', 'whatsapp']"  fixed-width/> WhatsApp</span></div>
    <div class="contact-option" v-if="option === 'link'"><span><fa-icon icon="link"  fixed-width /> Link</span></div>
  </div>
</template>

<script>
  export default {
    name: 'CurrentOption',
    props: {
      option: {
        type: String,
        required: true
      }
    },
    methods: {
      onBack() {
        this.$emit('back')
      }
    }
  }
</script>

<style lang="scss">
@import "CurrentOption";
</style>
